import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildoutLogo } from 'helpers/custom_fontawesome_icons';
import CallListOffMarketResultsHeader from './call_list_off_market_header';
import CallListOffMarketResultsCardList from './call_list_off_market_results_card_list';
import { useSelector } from 'react-redux';
import { selectCallListItems } from '../store/selectors/results';
import { selectLoading } from '../store/selectors/ui';

type CallListOffMarketResultsProps = {
  containerRef: React.MutableRefObject<null | HTMLDivElement>;
  lastUpdatedMap?: Map<number, Date>;
}

export default function CallListOffMarketResults({
  containerRef,
  lastUpdatedMap
}: CallListOffMarketResultsProps) {
  const [selectedCallListItemIds, setSelectedCallListItemIds] = useState<Set<number>>(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const callListItems = useSelector(selectCallListItems);
  const loading = useSelector(selectLoading);

  useEffect(() => {
    setSelectedCallListItemIds(new Set());
    setSelectAll(false);
  }, [callListItems]);

  const handleSelectToggle = (callListItemId: number) => {
    if (selectAll) {
      setSelectAll(false);
      const ids = new Set<number>();
      callListItems.forEach((result) => {
        if (callListItemId !== result.id) ids.add(result.id);
      });

      setSelectedCallListItemIds(ids);
    } else if (selectedCallListItemIds.has(callListItemId)) {
      setSelectedCallListItemIds(prev => new Set([...prev].filter(id => id !== callListItemId)));
    } else {
      setSelectedCallListItemIds(previousState => new Set([...previousState, callListItemId]));
    }
  };

  const handleToggleAllSelected = () => {
    setSelectedCallListItemIds(new Set());
    setSelectAll(!selectAll);
  };

  if (loading && callListItems.length === 0) {
    return (
      <div className="text-center py-4">
        <FontAwesomeIcon beatFade className="text-primary" icon={faBuildoutLogo} size="3x" />
      </div>
    );
  }

  const COMMON_PROPS = {
    selectAll,
    selectedCallListItemIds,
  };

  return (
    <div className="h-100 d-flex flex-column">
      <CallListOffMarketResultsHeader
        {...COMMON_PROPS}
        onToggleAllSelected={handleToggleAllSelected}
      />
      <CallListOffMarketResultsCardList
        {...COMMON_PROPS}
        containerRef={containerRef}
        lastUpdatedMap={lastUpdatedMap}
        onSelectToggle={handleSelectToggle}
      />
    </div>
  );
}
